<template>
  <div class="ts-w-full">
    <div v-for="(subBlock, subBlockName) in dataBody" class="ts-mb-10 ts-relative">
      <div class="ts-mb-1 ts-w-full subblock-name">
        <span class="ts-text-lg ts-font-semibold text-primary subblock-name__text">{{ subBlockName }}</span>
      </div>
      <div>
        <table class="table table-bordered table-hover ui-table ts-table">
          <thead>
            <th class="ts-text-center">Description</th>
            <th class="ts-text-center" colspan="2">Amount</th>
          </thead>
          <tbody>
            <tr v-for="item in subBlock">
              <td class="ts-whitespace-no-wrap ts-text-gray-800 ts-font-semibold">{{ item.dispay_name }}</td>
              <td class="ts-whitespace-no-wrap ts-text-gray-700" style="width: 107px; text-align: right;">
                {{ item.display_side === 'R' ? formatPrice(item.field_value) : '' }}
              </td>
              <td class="ts-whitespace-no-wrap ts-text-gray-700" style="width: 107px; text-align: right;">
                {{ item.display_side === 'L' ? formatPrice(item.field_value) : '' }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['dataBody'],
  methods: {
    formatPrice(value) {
        let val = (value/1).toFixed(2).replace(',', '.')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    }
}
}
</script>

<style lang="scss" scoped>
.subblock-name {
  &__text {
    padding: 0 0;
    display: inline-block;
  }
}
</style>
